import {ErrorHandler, Injectable} from '@angular/core';
import {ErrorFabricService} from './error-fabric.service';
import {ErrorNotifierService} from './error-notifier.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
    constructor(
        private notifier: ErrorNotifierService,
        private errorFactory: ErrorFabricService
    ) {}

    handleError(uncaughtError) {
        const error = this.errorFactory.create(uncaughtError.rejection || uncaughtError);
        error.uncaught = true;
        this.notifier.handleError(error);
    }
}
